import * as React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import * as apiClient from '../../api/apiClient';
import { apxBaseUrl } from '../../config';
import { redirectToLogin } from '../../helpers/util';
import { FlexDiv } from '../styled/Flex';
import { HeaderMenuButton } from '../styled';

const mapStateToProps = (state: any) => ({
  user: state.appData.user,
  language: state.appData.language,
});
type Props = ReturnType<typeof mapStateToProps>;
class HeaderMenu extends React.Component<Props> {
  handleLogout = async () => {
    const apxUrl = apxBaseUrl || '';
    await apiClient.post(apxUrl, '/logout');
    redirectToLogin();
  };

  render() {
    return (
      <FlexDiv>
        {
          this.props.user &&
          <HeaderMenuButton onClick={this.handleLogout}><FormattedMessage id="logout" /></HeaderMenuButton>
        }
      </FlexDiv>
    );
  }
}

export default connect<Props>(mapStateToProps)(HeaderMenu);
